import { render, staticRenderFns } from "./MlSidebar.vue?vue&type=template&id=4be980d6&scoped=true&"
import script from "./MlSidebar.vue?vue&type=script&lang=js&"
export * from "./MlSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be980d6",
  null
  
)

export default component.exports